import axios from 'axios';

export const BALANCE_STALE_EVENT = 'tottalo:balance-stale';

export interface BalanceSnapshot {
  balance: number;
  ledger_id?: number;
}

/**
 * Current balance of the logged-in player (from the access token). One cheap
 * read; the caller throttles it. Returns null on any failure, including an
 * API that does not have the route yet.
 */
export async function fetchBalance(): Promise<BalanceSnapshot | null> {
  const baseUrl = process.env.REACT_APP_GAME_API_BACKEND_API ?? '';
  try {
    const response = await axios.get(`${baseUrl}/balance`, {
      headers: { 'Cache-Control': 'no-cache' },
    });
    const balance = Number(response.data?.balance);
    if (!Number.isFinite(balance)) return null;
    const ledger = Number(response.data?.ledger_id);
    return {
      balance,
      ledger_id: Number.isFinite(ledger) ? ledger : undefined,
    };
  } catch {
    return null;
  }
}

/** Ask the app to re-read the balance, e.g. right after a bet or a deposit. */
export function requestBalanceRefresh() {
  window.dispatchEvent(new Event(BALANCE_STALE_EVENT));
}
